import React from 'react'
import { Text as RNText } from 'react-native-web'
import { useStudentTheme } from './theme/studentTheme'

interface TextProps {
  variant?: string
  children?: React.ReactNode
  style?: any
  content?: string
  testID?: string
  [key: string]: any
}

interface TypographyVariant {
    fontSize: string,
    color: string,
    fontFamily: string,
    fontWeight: string | number,
    letterSpacing?: string,
    margin?: string,
    lineHeight?: string,
}

const Text = ({
                variant,
                children,
                style,
                content,
              }: TextProps) => {
  const theme: any = useStudentTheme()
  const variantStyle: TypographyVariant = theme.typography[variant]
  return <RNText style={[{ fontFamily: 'Montserrat', color: theme.palette.mainText.main }, variantStyle, style ]} >
{
  children ?? content
}
</RNText>
}

export default Text
